import {
  getColumnIndex,
} from '../../../../components/gsheet';
import {
  NRTI_NNRTI, PI, INSTI, CAI
} from '../../../../constants';

const DRUG_INHIBITORS = {
  'PR': PI,
  'RT': NRTI_NNRTI,
  'IN': INSTI,
  'CA': CAI,
};


export default function updateData(
  rawDataCollection, rows, old_header) {

  const header = rows.shift();
  const drugList = header.slice(old_header.length).filter((name) =>
    name.toLowerCase().includes('fold')
  ).map((name) => {
    return name.replace('fold', '').trim();
  });

  const {seqType} = rawDataCollection;
  const isClinial = (!seqType || seqType === 'ClinicalList');
  const isLabList = !isClinial;

  const suscResults = [];

  for (const row of rows) {
    let genes = row[getColumnIndex(header, 'Gene')];
    if (genes.includes(',')) {
      genes = genes.split(',');
    } else {
      genes = genes.split(';');
    }

    genes = genes.map((gene) => gene.trim());

    // const drugValues = row.slice(old_header.length);

    let hasSuscResult = false;

    if (drugList.length === 0 && !isClinial) {
      for (const gene of genes) {
        const record = getSuscRecord(row, header, gene, isLabList);
        suscResults.push(record);
        hasSuscResult = true;
      }
    } else {
      drugList.map((drugName) => {
        const drugValue = row[getColumnIndex(header, drugName + ' fold')] || '';
        if (!drugValue) {
          return;
        }

        const drugResult = row[getColumnIndex(header, drugName + ' abs value')] || '';
        const drugInfo = {
          drugName: drugName,
          result: getFoldValue(drugResult),
          resultMatch: getFoldMatch(drugResult),
          fold: getFoldValue(drugValue),
          foldMatch: getFoldMatch(drugValue),
        };

        const drugAppliedToGene = genes.map((gene) => {
          const inhibitors = DRUG_INHIBITORS[gene];
          if (inhibitors.includes(drugName)) {
            return gene;
          } else {
            return null;
          }
        }).filter((gene) => (gene !== null));

        if (drugAppliedToGene.length > 0) {
          drugAppliedToGene.map((gene) => {
            let record = getSuscRecord(row, header, gene, isLabList);
            suscResults.push(Object.assign({}, record, drugInfo));
            hasSuscResult = true;
          });
        } else {
          genes.map((gene) => {
            let record = getSuscRecord(row, header, gene, isLabList);
            suscResults.push(Object.assign({}, record, drugInfo));
            hasSuscResult = true;
          });
        }
      });
    }

    if (!hasSuscResult && !isClinial) {
      for (const gene of genes) {
        const record = getSuscRecord(row, header, gene, isLabList);
        suscResults.push(record);
      }
    }
  }

  rawDataCollection.rawSuscResults = suscResults;

  return rawDataCollection;
}

function getSuscRecord(row, header, gene, isLabList=false) {
  let ptAlias = null;
  if (isLabList) {
    ptAlias = 'LabStrain';
  } else {
    ptAlias = row[getColumnIndex(header, 'PtAlias')];
  }
  const record = {
    ptAlias: ptAlias,
    isolateName: row[getColumnIndex(header, 'Isolate Name')],
    method: row[getColumnIndex(header, 'Method')],
    gene: gene,
    ic: row[getColumnIndex(header, 'IC')] || '50',
  };
  return record;
}

function getFoldValue(foldString) {
  let foldValue = foldString.match(/[\d.]+/);
  if (foldValue) {
    foldValue = foldValue[0];
  } else {
    foldValue = null;
  }
  return foldValue;
}

function getFoldMatch(foldString) {
  let foldMatch = foldString.match(/[^\d.]+/);
  if (!foldMatch) {
    foldMatch = '=';
  } else {
    foldMatch = foldMatch[0].trim();
  }
  return foldMatch;
}



// WEBPACK FOOTER //
// ./src/views/wizard/susc-results/gtable/update-data.js